var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVaccination = function SvgVaccination(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Monique",
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vacc{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flu_Shot",
    "data-name": "Flu Shot"
  }, /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 59.23,
    y1: 34.51,
    x2: 74.03,
    y2: 49.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "vacc",
    x: 49.1,
    y: 37.31,
    width: 12.88,
    height: 31.38,
    transform: "translate(53.74 -23.74) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 71.18,
    y1: 29.39,
    x2: 79.15,
    y2: 37.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 66.63,
    y1: 41.91,
    x2: 75.17,
    y2: 33.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "vacc",
    points: "42.16 68.65 39.89 66.38 42.73 62.39 46.15 65.81 42.16 68.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 41.03,
    y1: 67.51,
    x2: 28.51,
    y2: 80.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 47.85,
    y1: 60.69,
    x2: 51.84,
    y2: 64.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 51.27,
    y1: 57.27,
    x2: 55.25,
    y2: 61.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 54.68,
    y1: 53.86,
    x2: 58.66,
    y2: 57.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 58.1,
    y1: 50.44,
    x2: 62.08,
    y2: 54.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "vacc",
    x1: 61.51,
    y1: 47.03,
    x2: 65.49,
    y2: 51.01
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVaccination, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vaccination.f1f5b7a8.svg";
export { ForwardRef as ReactComponent };